"use client";

import type { MouseEventHandler, ReactNode } from "react";

import { cn } from "../../utils";
import Button from "../button/Button";
import { ChevronLeftIcon } from "../icons";
import { useDialogStack } from "./stack/context";

export interface DialogBackProps {
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  children?: ReactNode;
  /** Render even on the base view, where it does nothing. */
  alwaysVisible?: boolean;
}

const Back = ({ className, onClick, disabled = false, children, alwaysVisible = false }: DialogBackProps) => {
  const { canGoBack, back } = useDialogStack();

  if (!canGoBack && !alwaysVisible) {
    return null;
  }

  return (
    <Button
      icon={!children}
      size="xs"
      color="secondary"
      variant="ghost"
      aria-label="Back"
      disabled={disabled}
      className={cn("shrink-0", className)}
      onClick={event => {
        onClick?.(event);
        if (!event.defaultPrevented) {
          back();
        }
      }}
    >
      {children ?? <ChevronLeftIcon className="h-5 w-5" />}
    </Button>
  );
};

Back.displayName = "DialogBack";

export default Back;
